import { render } from "./OrganizationBusinessQueryNotificationFields.vue?vue&type=template&id=19d63f74"
import script from "./OrganizationBusinessQueryNotificationFields.vue?vue&type=script&lang=js"
export * from "./OrganizationBusinessQueryNotificationFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__